import {createAsyncThunk} from '@reduxjs/toolkit';
import {filtersApi} from 'api';
import {IEntityBase} from 'models';
import {prefix} from './config';
import {toastNotificationManager} from 'toast-notifications';

export const fetchAreasFiltersThunk: any = createAsyncThunk<IEntityBase[]>(
  `${prefix} fetchAreas`,
  async (_, {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await filtersApi.getAreas();
      return parsedBody;
    } catch (error) {
      dispatch(
        toastNotificationManager.createErrorToastAction(
          error.parsedBody || error.statusText || 'Failed to fetch areas. Unknown error occurred.'
        )
      );
      return rejectWithValue(error);
    }
  }
);
